module.exports = __webpack_public_path__ + "static/media/instagram.09d1dc5e.svg";